import { Divider } from "antd";
import React from "react";
import { styled } from "styled-components";
import BelievesModal from "./BelieveModal";
import OurAimsModal from "./OurAimsModal";
import WorkingModal from "./WorkingModal";
import {
  ColumnContainer,
  MainText,
  SubText,
} from "../../../../helpers/StyledComponents";
import TitleHeader from "../../../../components/Common/TitleHeader";

const Vision = () => {
  return (
    <ColumnContainer>
      <TitleHeader th="วิสัยทัศน์" center />
      <MainText align="center" indent>
        SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน
        เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า
        และหนุนใจให้ทุกคนติดสนิทกับพระเจ้าทุกวัน ผ่านการอธิษฐานและอ่านพระคัมภีร์
        เพื่อให้พวกเขาได้รับเชื่อพระเยซูเป็นการส่วนตัว เติบโตขึ้นในความเชื่อ
        และเป็นสมาชิกที่เข้มแข็งของคริสตจักรและเป็นผู้รับใช้ที่ซื่อสัตย์
      </MainText>
      <SubText indent>
        องค์การคริสตธรรมสัมพันธ์ประเทศไทย หรือ SU Thailand เป็นเครือข่ายของ
        Scripture Union International (SU International)
        ซึ่งเป็นองค์กรสากลดำเนินงานในประเทศต่างๆ กว่า 120 ประเทศ ทั้งในอเมริกา
        คานาดา แอฟริกา ยุโรป ออสเตรเลีย นิวซีแลนด์ และ ประเทศต่างๆ ในเอเชีย เช่น
        สิงคโปร์ มาเลเซีย ฮ่องกง ซึ่งมีพื้นฐานความเชื่อในคริสตศาสนา
        และมีภาระใจและความมุ่งหมายที่จะส่งเสริมและสนับสนุน การอ่านพระคัมภีร์
        การอธิษฐาน และการประกาศพระกิตติคุณกับเด็กและครอบครัว
        มีการประสานงานและแบ่งปันความรู้ ประสบการณ์ และทรัพยากร
      </SubText>
      <Divider />
      <MainText indent>วิธีการทำพันธกิจของเรา</MainText>
      <SubText>
        1. เราจัดหาทรัพยากรที่เกี่ยวกับการอ่าน การเรียน
        และการสอนตามหลักพระคัมภีร์ ให้กับโรงเรียนและคริสตจักร We will provide
        resources to schools and churches
        <br />
        2. เราจัดการฝึกอบรมและเตรียมครูเพื่อโรงเรียนและคริสตจักร We will provide
        trainings to equip teachers in schools and churches
        <br />
        3. เราร่วมมือกับแต่ละบุคคล คริสตจักร องค์กร สถาบัน และโรงเรียน
        ที่จะเข้าถึงและเสริมสร้างเด็ก เยาวชน และครอบครัว We will partner with
        like-minded individuals, churches, organizations and schools to reach
        and nurture children, young people and families
      </SubText>
      <Divider />
      <MainText indent>ค่านิยมหลัก OUR CORE VALUES</MainText>
      <SubText>
        <ul>
          <li>ถ่อมใจ (Humility) - รับใช้และให้เกียรติซึ่งกันและกัน</li>
          <li>
            มีจรรยาบรรณ (Ethical) - ทําทุกงานด้วยความซื่อสัตย์และมีคุณธรรม
          </li>
          <li>
            ยึดหลักพระคัมภีร์ (Scripture-based) - สอนและทำตามหลักพระคัมภีร์
          </li>
          <li>เชื่อถือและวางใจได้ (Trustworthy) - เป็นพันธมิตรที่ไว้ใจได้</li>
          <li>ทํางานเป็นทีม (Teamwork) - ใช้ของประทานทํางานประสานกัน</li>
          <li>
            รับผิดชอบ (Accountability) – ทําทุกอย่างด้วยความรับผิดชอบต่อพระเจ้า
          </li>
        </ul>
      </SubText>
      <SubText indent>
        ตั้งแต่ปี ค.ศ. 1960 SU International
        ได้มีการเห็นชอบร่วมกันในการประชุมสมัชชานานาชาติ SU International
        ในเรื่องของความมุ่งหมาย (Aims) ความเชื่อ (What we believe)
        และหลักการในการทำงาน (Working Principles)nd schools to reach and nurture
        children, young people and families
      </SubText>
      <SubText indent>
        Scripture Union is an international Christian charity working with
        churches in more than 130 countries providing resources to bring the
        good news about Jesus Christ to children, young people and families -
        and to encourage them to develop spiritually through the Bible and
        prayer. As well as co-ordinating a network of volunteers, staff and
        associates who run holidays, church-based events and school Christian
        groups, we produce a wide range of publications and support those who
        use our resources through programmes.
      </SubText>
      <Divider />
      <ButtonSection>
        <OurAimsModal />
        <BelievesModal />
        <WorkingModal />
      </ButtonSection>
      <Divider />
    </ColumnContainer>
  );
};

const ButtonSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export default Vision;
